import PaymentIcons from './PaymentIcons'

export default PaymentIcons
